/**
 * @license
 * Copyright (c) 2017, Barclays Africa Technology, All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file
 */

import { Injectable } from '@angular/core';
import { go } from "@ngrx/router-store";

import { Observable } from 'rxjs/Observable';
import { Subscriber } from 'rxjs/Subscriber';

import { User } from '@api/models/user';

declare var window: any;

import { AuthenticationService } from '../../celine/services/authentication.service';
import { User as clientUser } from 'oidc-client';
// import { FGWService } from '@threshold/services/fgw.service';

/**
 * Version of AuthenticationService for Connected Experience
 */
@Injectable()
export class AuthenticationConnectedService implements AuthenticationService {

    private oidc: any;
    private baseUrl = JSON.parse(window['__CONFIGURATION'])['authUrl'];
    private isOnline = false;

    /**
     * Create the new instance of AuthenticationService
     */
    constructor () {
        // Get oidc from the Window object
        this.oidc = window._oidc;
        // console.log(this.oidc);
    }


    onlineCheck() {
        let xhr = new XMLHttpRequest();
        return new Promise((resolve, reject) => {
            xhr.onload = () => {
                // Set online status
                this.isOnline = true;
                resolve(true);
            };
            xhr.onerror = () => {
                // Set online status
                this.isOnline = false;
                reject(false);
            };
            xhr.open('GET', this.baseUrl, true);
            xhr.send();
        });
    }

    /**
     * Login
     * @return Observable User's information
     */
    public login(): Observable<User> {

        if (!window['__NOT_USE_AUTHENICATION']) {

            return Observable.create((subscriber: Subscriber<User>) => {
                this.oidc.getUser().then((oidcUser: clientUser) => {
                    let userName: string = oidcUser.profile.preferred_username ? oidcUser.profile.preferred_username : '';
                    let firstName: string = oidcUser.profile.given_name ? oidcUser.profile.given_name : '';
                    let lastName: string = oidcUser.profile.family_name ? oidcUser.profile.family_name : '';
                    let userProfileId: string = oidcUser.profile.sub ? oidcUser.profile.sub : '';
                    let user: User = {
                        id: userProfileId,
                        username: userName.trim(),
                        firstName: firstName.trim(),
                        lastName: lastName.trim(),
                        roles: [],
                        application: 'threshold',
                        attributes: oidcUser
                    };

                    // instana user
                    ineum('user', oidcUser.profile.sub);

                    // window.addEventListener('RUMSCRIPT.READY', (event) => {
                    //     aat('addSessionAttributes', { celineVersion: '1', angularCore: '4.4.6' });
                    //     // clean up
                    //     window.removeEventListener('RUMSCRIPT.READY', event)
                    // })

                    // fraud fabric tracker
                    if ((typeof fft !== 'undefined')) {
                        fft('username', user.username);
                        fft('session', oidcUser.profile.sid ? oidcUser.profile.sid : '');
                    }

                    subscriber.next(user);
                    subscriber.complete();
                });
            });
        }
        else {
            return Observable.create((subscriber: Subscriber<User>) => {

                let user: User = {
                    id: 'test-id',
                    username: 'test-username',
                    firstName: '',
                    lastName: '',
                    roles: [],
                    application: 'threshold'
                };

                // fraud fabric tracker
                if ((typeof fft !== 'undefined')) {
                    fft('username', user.username);
                    fft('usergroup', '0');
                    fft('session', '');
                }

                // window.addEventListener('RUMSCRIPT.READY', (event) => {
                //     aat('allowCookies', false);
                //     aat('addSessionAttributes', { celineVersion: '1', angularCore: '4.4.6' });
                //     window.removeEventListener('RUMSCRIPT.READY', event)
                // })

                subscriber.next(user);
                subscriber.complete();

            });
        }

    }

    /**
     * Log out from the active session
     */
    public logout() {

        this.onlineCheck().then(() => {
            // Has internet connection, carry on
            if (this.oidc) {
                this.oidc.getUser().then(user => {
                    // pass id_token
                    this.oidc.signoutRedirect({ id_token_hint: user.id_token }).then(function (resp) {
                        sessionStorage.removeItem('doNotShowMobileModalThisSession');
                        this.oidc.removeUser();
                        sessionStorage.removeItem('_isAuthorized');
                        sessionStorage.removeItem('authorizationDataIdToken');
                        sessionStorage.removeItem('authorizationData');
                        sessionStorage.removeItem('_isValidating');
                    }).catch(function (err) { });
                });
            }
        }).catch((e) => {
            // Has no internet connection, let the user know
            // window.location = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + `/#/session-expired`
        });


    }

    /**
     *
     * @param token
     */
    public parseJwt(token) {
        let base64Url = token.split('.')[1];
        let base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    };
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/authentication-threshold.service.ts